var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{attrs:{"type":"card"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"网站地图"}},[_c('WebsiteMap')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }